import { FC } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

type StepProgressBarProps = PropsWithClassName<{
  totalSteps: number;
  current: number;
}>;

const StepProgressBar: FC<StepProgressBarProps> = ({ totalSteps, current, className }) => (
  <div className={cn('flex gap-2 mb-6', className)}>
    {Array.from({ length: totalSteps }).map((_, i) => (
      <div key={i} className={cn('h-0.5 w-8 rounded-full transition-colors', i < current ? 'bg-black' : 'bg-black/20')} />
    ))}
  </div>
);

export default StepProgressBar;
